import { TAGS, api } from "@/store/api.ts"
import { balanceEndpoints } from "@/store/apis/balanceAPI"
import {
  IGetMyCompletedRes,
  IGetMyProgressRes,
  IQuest,
  IQuestCompleted,
  IQuestCompletedRaw
} from "."

export const questsApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.QUESTS]
})

export const questsEndpoints = questsApi.injectEndpoints({
  endpoints: (builder) => ({
    getQuests: builder.query<IQuest[], void>({
      query: () => ({ url: "/cod-quests", method: "GET" }),
      providesTags: () => [{ type: TAGS.QUESTS, id: "LIST" }]
    }),

    getMyCompleted: builder.query<IGetMyCompletedRes, void>({
      query: () => ({ url: "/cod-quests/me/completed", method: "GET" }),
      providesTags: () => [{ type: TAGS.QUESTS, id: "MY_COMPLETED" }]
    }),

    getMyProgress: builder.query<IGetMyProgressRes, void>({
      query: () => ({ url: "/cod-quests/me/progress", method: "GET" }),
      providesTags: () => [{ type: TAGS.QUESTS, id: "MY_PROGRESS" }]
    }),

    claimQuest: builder.mutation<IQuestCompletedRaw, string>({
      query: (id) => ({ url: `/cod-quests/${id}/claim`, method: "POST" }),
      onQueryStarted: async (
        questId,
        { dispatch, queryFulfilled, getState }
      ) => {
        try {
          const { data } = await queryFulfilled

          const questsState =
            questsEndpoints.endpoints.getQuests.select()(getState())
          const quest = questsState.data?.find((q) => q._id === questId)

          if (quest) {
            dispatch(
              balanceEndpoints.util.updateQueryData(
                "getBalance",
                undefined,
                (draft) => {
                  draft.goldenDust += quest.rewardGoldenDust
                }
              )
            )

            dispatch(
              questsEndpoints.util.updateQueryData(
                "getMyCompleted",
                undefined,
                (draft) => {
                  const entry: IQuestCompleted = {
                    _id: data._id,
                    player: data.player,
                    quest,
                    isClaimed: data.isClaimed,
                    completedAt: data.completedAt
                  }
                  const idx = draft.items.findIndex(
                    (c) => c.quest._id === questId
                  )
                  if (idx === -1) {
                    draft.items.push(entry)
                    draft.total += 1
                  } else {
                    draft.items[idx] = entry
                  }
                }
              )
            )
          }
        } catch (error) {
          console.error(error)
        }
      }
    })
  })
})

export const {
  useGetQuestsQuery,
  useGetMyCompletedQuery,
  useGetMyProgressQuery,
  useClaimQuestMutation
} = questsEndpoints
